// Duplicated from service-desk — code duplication is accepted between dashboard-ui and service-desk

export enum WorkitemStatus {
  ASSIGNED_TO_ME = 'Assigned to Me',
  IN_CQA = 'IN_CQA',
  CQA_COMPLETE = 'CQA_COMPLETE',
  CQA_APPROVED = 'CQA_APPROVED',
  CQA_CLOSED = 'CQA_CLOSED',
}

export interface ViewFilter {
  key?: string;
  operation?: string;
  value?: unknown;
  [key: string]: any;
}

export interface Collection {
  collection_id?: string;
  name?: string;
  availability?: boolean;
  assignee_ids?: string[] | null;
  filters?: ViewFilter[];
  project_configuration?: Record<string, any>;
  [key: string]: any;
}

export interface CollectionWithWorkItemCounts extends Collection {
  rubricVersionId?: number;
  workItemCounts?: {
    [WorkitemStatus.ASSIGNED_TO_ME]: number;
    [WorkitemStatus.IN_CQA]: number;
    [WorkitemStatus.CQA_COMPLETE]: number;
    [WorkitemStatus.CQA_APPROVED]: number;
    [WorkitemStatus.CQA_CLOSED]?: number;
  };
}
